import {
  TRACK_IDS,
  EDUCATION_JOYRIDE_TARGETS,
} from '@edulastic/constants/educationJoyrides'
import { sanitizeUrl } from '@edulastic/common/src/utils/html'
import { buildModerateEducationJoyrideStep } from '../constants'
import { getModerateTrackContent } from '../moderateTrackContent'
import {
  buildNotifyTrackStateAfterDismiss,
  resolveNotifyJoyrideVariant,
} from '../resolveJoyrideVariant'

export const PRODUCT_UPDATES_JOYRIDE_CONTENT = getModerateTrackContent(
  TRACK_IDS.PRODUCT_UPDATES
).body
export const PRODUCT_UPDATES_JOYRIDE_CTA = 'View Updates'
export const PRODUCT_UPDATES_JOYRIDE_EVENT = 'Product Updates Joyride'
export const PRODUCT_UPDATES_JOYRIDE_RESPONSES = {
  VIEW_UPDATES: 'view_updates',
  CLOSE: 'close',
}

// The sidebar footer can still be settling (expand transition, footer
// reserve) when the tour starts; one re-measure keeps the arrow on the item.
export const PRODUCT_UPDATES_JOYRIDE_REPOSITION_DELAY_MS = 350

// Same sidebar-anchored floater tuning as the CURRICULUM_PA track.
const SIDEBAR_FLOATER_PROPS = {
  offset: 12,
  options: {
    flip: { enabled: false },
    preventOverflow: { boundariesElement: 'viewport', padding: 16 },
  },
}

/**
 * Product Updates notify tour: a single moderate step on the sidebar's
 * Product Updates item, shown once per EA "Notify Users".
 * `trackContext`: { notifiedAt, url } from the PRODUCT_UPDATES tile.
 */
export const PRODUCT_UPDATES_TRACK_CONFIG = {
  target: EDUCATION_JOYRIDE_TARGETS.PRODUCT_UPDATES,
  // The item sits in the fixed sidebar footer; nothing to scroll.
  scrollIntoView: false,
  // Keep focus where it was after dismissal; the sidebar collapses back.
  focusTargetOnDismiss: false,
  repositionAfterStartMs: PRODUCT_UPDATES_JOYRIDE_REPOSITION_DELAY_MS,
  // Continuous so the CTA reports NEXT and the X reports CLOSE (Segment
  // distinguishes them). Only `last` (CTA) and `close` (X aria-label) render.
  continuous: true,
  locale: {
    last: PRODUCT_UPDATES_JOYRIDE_CTA,
    close: 'Close',
  },
  // The CTA ("View Updates") opens the notified Product Updates page in a new
  // tab; the tour is dismissed as for any CTA.
  onCtaClick: ({ trackContext }) => {
    if (!trackContext?.url) return
    window.open(sanitizeUrl(trackContext.url), '_blank', 'noopener,noreferrer')
  },
  resolveVariant: resolveNotifyJoyrideVariant,
  buildDismissedState: buildNotifyTrackStateAfterDismiss,
  buildSegmentEvent: ({ userResponse, trackContext }) => ({
    event: PRODUCT_UPDATES_JOYRIDE_EVENT,
    properties: {
      userResponse:
        userResponse === 'Close'
          ? PRODUCT_UPDATES_JOYRIDE_RESPONSES.CLOSE
          : PRODUCT_UPDATES_JOYRIDE_RESPONSES.VIEW_UPDATES,
      url: trackContext?.url,
      notifiedAt: trackContext?.notifiedAt,
      pagePath: window.location.pathname,
    },
  }),
  buildStep: ({ target, titleId, descId }) => {
    const { title } = getModerateTrackContent(TRACK_IDS.PRODUCT_UPDATES)
    return {
      ...buildModerateEducationJoyrideStep({
        target,
        title,
        body: PRODUCT_UPDATES_JOYRIDE_CONTENT,
        placement: 'right',
        floaterProps: SIDEBAR_FLOATER_PROPS,
        titleId,
        descId,
      }),
      disableScrollParentFix: true,
    }
  },
}
